import { deviceTypes } from "../../consts";

const monoDevices = [
  deviceTypes.DEV_TYPE_P1V30M,
  deviceTypes.DEV_TYPE_P4_M3_G1,
  deviceTypes.DEV_TYPE_P4_M3_G2,
  deviceTypes.DEV_TYPE_P1V40D_CONTROL,
  deviceTypes.DEV_TYPE_P1V31M,
  deviceTypes.DEV_TYPE_P1_ARIANE
];

const chargers = [
  deviceTypes.DEV_TYPE_V24_CHARGER,
  deviceTypes.DEV_TYPE_V24P_CHARGER,
  deviceTypes.DEV_TYPE_P1V30_CHARGER,
  deviceTypes.DEV_TYPE_P1V31_CHARGER,
  deviceTypes.DEV_TYPE_P1V40V_CHARGER,
  deviceTypes.DEV_TYPE_P1V40C_CHARGER
];

const holders = [
  deviceTypes.DEV_TYPE_V24_HOLDER,
  deviceTypes.DEV_TYPE_V24P_HOLDER,
  deviceTypes.DEV_TYPE_P1V30_HOLDER,
  deviceTypes.DEV_TYPE_P1V31_HOLDER,
  deviceTypes.DEV_TYPE_P1V40V_HOLDER_CONTROL,
  deviceTypes.DEV_TYPE_P1V40C_HOLDER_CONTROL
];

const deviceGroups = {
  monoDevices: monoDevices,
  chargers: chargers,
  holders: holders
};

export default deviceGroups;
